// extracted by css-extract-rspack-plugin
export default {"popoverFrame":"src-wab-client-plasmic-plasmic_kit_data_binding-PlasmicPopoverFrame-module__popoverFrame-k5ZeX_","propTitle":"src-wab-client-plasmic-plasmic_kit_data_binding-PlasmicPopoverFrame-module__propTitle-lvJEyQ","contentWrap":"src-wab-client-plasmic-plasmic_kit_data_binding-PlasmicPopoverFrame-module__contentWrap-Jjn8pK"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"popoverFrame\":\"src-wab-client-plasmic-plasmic_kit_data_binding-PlasmicPopoverFrame-module__popoverFrame-k5ZeX_\",\"propTitle\":\"src-wab-client-plasmic-plasmic_kit_data_binding-PlasmicPopoverFrame-module__propTitle-lvJEyQ\",\"contentWrap\":\"src-wab-client-plasmic-plasmic_kit_data_binding-PlasmicPopoverFrame-module__contentWrap-Jjn8pK\"}";
        // 1793541993492
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  